<div class="wrap-carousel-list">
  <p-carousel [value]="listNewsInput" [numVisible]="4" [numScroll]="4" [circular]="false"
    [responsiveOptions]="responsiveOptions">
    <ng-template let-news pTemplate="item">
      <div (click)="showDialog(news)" class="item-news">
        <!-- <div class="item-news"> -->
        <div class="w-100" class="wrap-img mb-1">
          <img class="w-100"
            src="{{news?.photo?.[0]?.url ? news?.photo?.[0]?.url : '/src-adisco/assets/images/image-default.jpeg' }}"
            alt="news-list-photo">
        </div>
        <p class="supplier mb-0">
          {{ news?.supplierName }}
        </p>
        <p *ngIf="news?.subject" class="title-news font-bold mb-2">{{news?.subject ?
          news?.subject : ''}}
        </p>
        <p class="desc mb-1" *ngIf="news.description" [innerHTML]="news.description"></p>
        <a href="#">En savoir plus</a>
      </div>
    </ng-template>
  </p-carousel>
</div>
<p-dialog [header]="newsDetail?.supplierName ? newsDetail?.supplierName : ''" [modal]="true" [(visible)]="visible"
  [style]="{ width: '1100px' }">
  <div class="loading" *ngIf="isLoadingNewsDetail">
    <img src="/src-adisco/assets/images/icon/loading.gif" alt="">
  </div>
  <div class="popup-news" *ngIf="!isLoadingNewsDetail">
    <p class="title-news font-bold"> {{newsDetail?.subject}}</p>
    <div class="d-flex" style="max-height: 678px;">
      <div class="d-flex wrap-img w-50">
        <img
          [src]="newsDetail?.photo?.[0]?.url ? newsDetail?.photo?.[0]?.url : '/src-adisco/assets/images/image-default.jpeg'"
          alt="news-detail-photo">
        <div class="wrap-anchor d-flex align-items-center gap-3">
          <div *ngIf="newsDetail?.file" class="wrap-file w-6 p-2">
            <a class="d-flex align-items-center gap-3" href="#" (click)="onDownload($event)" target="_blank">
              <img src="src-adisco/assets/images/icon/file-text.png" alt="file-icon" />
              <div class="wrap-text">
                <p class="mb-0 font-bold">{{newsDetail?.file?.title}}</p>
                <p class="mb-0">{{newsDetail?.file?.file?.[0]?.name}}</p>
              </div>
            </a>
          </div>
          <a *ngIf="newsDetail?.externalLink" class="a-link w-6" [href]="newsDetail?.externalLink" target="_blank">Lien hypertexte</a>
        </div>
      </div>
      <div *ngIf="newsDetail?.summary" class="wrap-content w-50">
        <p [innerHTML]="newsDetail?.summary"></p>
      </div>
    </div>
  </div>
</p-dialog>